// extracted by mini-css-extract-plugin
export default {"root":"YDVgQ0TW7Ade3xUNcEQz","title":"W7sOxd3w4WmAKgCBXWB9","settings":"nMDetJEBxQP1P8vsy3gy"};